import {
  PriceListDetailFormValues,
  PriceListEditFormValues,
  PriceListSearchFormValues,
  PriceTable,
} from "./types";

/*-------------------------------------------------------------------------------------------
   SETTING - PRICE LIST SEARCH
---------------------------------------------------------------------------------------------*/
export const initialPriceListSearchForm: PriceListSearchFormValues = {
  search: "",
};
/*-------------------------------------------------------------------------------------------
       PRICE LIST - DETAIL
  ---------------------------------------------------------------------------------------------*/

export const initialPriceListDetailForm: PriceListDetailFormValues = {
  id: null,
};

/*-------------------------------------------------------------------------------------------
     SETTING - PRICE LIST EDIT
---------------------------------------------------------------------------------------------*/

export const initialPriceListEditForm: PriceListEditFormValues = {
  name: null,
  vehicleGroupId: null,
};

export const initialPriceTable: PriceTable = {
  id: null,
  name: null,
  rentDurations: [],
  rentVehicleModels: [],
  values: [],
};
